import { Pipe, PipeTransform } from '@angular/core';
import { ORDER_CONDITION } from '@app/_shared/shared.enums';

@Pipe({
  name: 'orderCondition'
})
export class OrderConditionPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    if (typeof (value) === 'number') {
      return ORDER_CONDITION[value]
    }
    return value
  }

}
